import { Component, Field } from '@contember/interface'

export const CategoryPreview = Component(() => (
	<div>
		<Field field="name" />
	</div>
))
